import { useCallback as t } from "react";
function r(r, e) {
  return t(function (t) {
    r.current = t, "function" == typeof e ? e(t) : "object" == typeof e && null !== e && (e.current = t);
  }, [r, e]);
}
export { r as default };